module.exports = __webpack_public_path__ + "img/2f6478fa717397f330e10d56444ea07a.svg";